import { createFileRoute } from '@tanstack/react-router';
import { ProjectsHead } from '@/features/projects/ui/ProjectsHead';
import { SheetReviewPage } from '@/features/sync/SheetReviewPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { readSyncSearch, syncSearchSchema, syncViewProps } from '@/features/sync/syncSearch';

export const Route = createFileRoute('/_authenticated/projects/review')({
  validateSearch: syncSearchSchema,
  component: function ProjectsReview() {
    const cur = readSyncSearch(Route.useSearch());
    const navigate = Route.useNavigate();
    return (
      <div className="flex flex-col gap-4">
        <ProjectsHead />
        <SheetReviewPage
          config={SHEET_TABS.projects}
          {...syncViewProps(cur, (search) => void navigate({ search, replace: true }))}
        />
      </div>
    );
  },
});
